import { getLocalAccessToken } from "../../utils/helper";
import api, {
  handleErrorCreateAndUpdate,
  handleErrorShowCache,
} from "../../services/api";
import { Toast } from "../../components/notify/Notify";
import { url } from "../../constants/path";
const accessToken = getLocalAccessToken();

api.defaults.headers.common["Authorization"] = "Bearer " + accessToken;

const URL = url.flfPairingType;

/*  
   PAIRING TYPE FPT LIFE
*/

export const createFLFPairingType = (data, callback) => {
  api
    .post(URL, data)
    .then((response) => {
      callback(response.data.data);
      Toast("success", "Thành công");
    })
    .catch((err) => {
      handleErrorCreateAndUpdate(err, callback);
    });
};

export const getFLFPairingType = (params = {}, callback) => {
  api
    .get(URL, { params })
    .then((response) => callback(response.data.data))
    .catch((err) => {
      Toast("warning", err.response.data.message);
    });
};

export const updateFLFPairingType = (id, data, callback) => {
  api
    .patch(`${URL}/${id}`, data)
    .then((response) => {
      callback(response.data.data);
      Toast("success", "Thành công");
    })
    .catch((err) => {
      handleErrorCreateAndUpdate(err, callback);
    });
};

//? remove iot partner
export const removeFLFPairingType = (id, callback) => {
  api
    .delete(`${URL}/${id}`)
    .then((response) => {
      Toast("success", "Thành công");
      callback(response);
    })
    .catch((err) => {
      Toast("warning", err.response.data.message);
    });
};

export const getCacheFLFPairingType = (callback) => {
  api
    .get(`${URL}/cache`)
    .then((response) => {
      callback(response.data.data);
    })
    .catch((err) => {
      handleErrorShowCache(err);
    });
};

export const clearCacheFLFPairingType = (callback) => {
  api
    .post(`${URL}/clear-cache`)
    .then((response) => {
      callback(response);
      Toast("success", "Thành công");
    })
    .catch((err) => {
      Toast("warning", err.response.data.message);
    });
};

export const deployCacheFLFPairingType = (callback) => {
  api
    .post(`${URL}/deploy-cache`)
    .then((response) => {
      callback(response);
      Toast("success", "Thành công");
    })
    .catch((err) => {
      Toast("warning", err.response.data.message);
    });
};
